"use strict";

var getSerializers = require('./serializers');

var _blocksToNodes = require('./blocksToNodes');

var getImageUrl = require('./getImageUrl');

var mergeSerializers = require('./mergeSerializers');

module.exports = {
  blocksToNodes: function blocksToNodes(renderNode, props, defaultSerializers, serializeSpan) {
    if (defaultSerializers) {
      return _blocksToNodes(renderNode, props, defaultSerializers, serializeSpan);
    } // Backwards-compatibility


    var serializers = getSerializers(renderNode);
    return _blocksToNodes(renderNode, props, serializers.defaultSerializers, serializers.serializeSpan);
  },
  getSerializers: getSerializers,
  getImageUrl: getImageUrl,
  mergeSerializers: mergeSerializers
};
//# sourceMappingURL=internals.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sanity/block-content-to-hyperscript/lib/internals.js
// module id = 190
// module chunks = 0